import OT from '@opentok/client'
import { setError, updateError } from 'interview/actions/sequenced-interview'
import VideoServices from 'services/video'
export const OPENTOK_AUTHENTICATE_TEST = 'opentok/authenticate-test'
export const OPENTOK_AUTHENTICATE_CANDIDATE = 'opentok/authenticate-candidate'
export const OPENTOK_START_ARCHIVE = 'opentok/start-archive'
export const OPENTOK_STOP_ARCHIVE = 'opentok/stop-archive'
export const OPENTOK_FETCH_TEST_SESSION_DATA_SUCCESS = 'opentok/fetch-test-session-data-success'
export const OPENTOK_FETCH_CANDIDATE_SESSION_DATA_SUCCESS = 'opentok/fetch-candidate-session-data-success'
export const OPENTOK_UPDATE_ARCHIVE_DATA_SUCCESS = 'opentok/update-archive-data-success'
export const OPENTOK_STREAMING_TOGGLE = 'opentok/streaming-toggle'
export const OPENTOK_RECORDING_TOGGLE = 'opentok/recording-toggle'
export const OPENTOK_STREAM_STARTING_TOGGLE = 'opentok/stream-starting-toggle'
export const OPENTOK_RECONNECTING_TOGGLE = 'opentok/reconnecting-toggle'
export const OPENTOK_CANDIDATE_SESSION_INIT = 'opentok/candidate-session-init'
export const OPENTOK_PUBLISHER_SET = 'opentok/publisher-set'
export const OPENTOK_SESSION_SET = 'opentok/session-set'
export const OPENTOK_SET_RECORDING_SESSION_DATA = 'opentok/set-recording-session-data'
export const OPENTOK_ERROR = 'opentok/error'
export const OPENTOK_RESET_DATA = 'opentok/reset'
export const OPENTOK_UPDATE_ARCHIVE_FROM_EVENT = 'opentok/update-archive-from-event'
export const OPENTOK_UPDATE_CONNECTION_COUNT = 'opentok/update-connection-count'
export const OPENTOK_RECORDING_SESSION_INIT = 'opentok/recording-session-init'
export const OPENTOK_PUBLISHER_ELEMENT_SET = 'opentok/publisher-element-set'

export const authenticateSession = uuid => (dispatch, getState, { emit }) => {
  if (uuid) {
    emit({ type: OPENTOK_AUTHENTICATE_CANDIDATE, payload: uuid })
  } else {
    emit({ type: OPENTOK_AUTHENTICATE_TEST })
  }
}

export const resetOpentokData = resetOpentokSessionData => (
  { type: OPENTOK_RESET_DATA, resetOpentokSessionData }
)

export const setOpentokError = error => ({ type: OPENTOK_ERROR, error })

export const setPublisher = payload => ({ type: OPENTOK_PUBLISHER_SET, payload })

export const setSession = session => ({ type: OPENTOK_SESSION_SET, session })

export const resetSessionAndPublisher = () => (dispatch) => {
  dispatch(setPublisher({ publisher: undefined }))
  dispatch(setSession(undefined))
}

export const initPublisher = (publisherOptions, publisherId) => (dispatch) => {
  const publisherElementId = publisherId || 'publisher'
  let publisher = OT.initPublisher(publisherElementId, publisherOptions, (err) => {
    if (err) {
      if (err.name === 'OT_USER_MEDIA_ACCESS_DENIED') {
        dispatch(updateError('allowMediaDevicesError'))
        dispatch(setOpentokError('PermissionDeniedError'))
      } else {
        dispatch(updateError('initPublisherError'))
        dispatch(setOpentokError('initPublisherError'))
      }
      publisher.destroy()
      publisher = null
    }
  })

  if (publisher) {
    dispatch(setPublisher({ publisher, publisherElementId: publisherId }))
  }
}

export const publishToSession = () => (dispatch, getState) => {
  const { session, publisher } = getState().global.opentok
  session.publish(publisher, (error) => {
    if (error) {
      const errorText = error.name || 'OPENTOK_ERROR'
      dispatch(setError(error))
      dispatch(setOpentokError(errorText))
    }
  })
}

export const connectToSession = (sessionToken, publisherElementId) => (dispatch, getState) => {
  const { session, candidateSessionData } = getState().global.opentok
  const token = sessionToken || candidateSessionData.token

  session.connect(token, (err) => {
    if (err) {
      const errorText = err.name || 'OPENTOK_ERROR'
      dispatch(setError(err))
      dispatch(setOpentokError(errorText))
    } else {
      const publisherOptions = {
        width: '100%',
        height: '100%',
        facingMode: 'user',
        showControls: false,
        style: {
          audioLevelDisplayMode: 'off',
          buttonDisplayMode: 'off',
        },
        insertMode: 'append',
        fitMode: 'contain',
      }
      dispatch(initPublisher(publisherOptions, publisherElementId))
    }
  })
}

export const disconnectSession = () => (dispatch, getState) => {
  const { session, publisher } = getState().global.opentok
  if (session) {
    if (publisher && publisher.session && publisher.stream) {
      session.unpublish(publisher)
    }
    session.disconnect()
  }
}

export const setRecordingSessionData = payload => ({ type: OPENTOK_SET_RECORDING_SESSION_DATA, payload })

export const startArchiving = payload => (dispatch, getState, { emit }) => {
  emit({ type: OPENTOK_START_ARCHIVE, payload })
}

export const stopArchiving = payload => (dispatch, getState, { emit }) => {
  emit({ type: OPENTOK_STOP_ARCHIVE, payload })
}
export const toggleReconnectingState = payload => ({ type: OPENTOK_RECONNECTING_TOGGLE, payload })

export const toggleStreamingState = payload => ({ type: OPENTOK_STREAMING_TOGGLE, payload })

export const updateArchiveData = archive => ({ type: OPENTOK_UPDATE_ARCHIVE_DATA_SUCCESS, archive })

export const updateArchiveFromEvent = archive => ({ type: OPENTOK_UPDATE_ARCHIVE_FROM_EVENT, archive })

export const updateConnectionCount = payload => ({ type: OPENTOK_UPDATE_CONNECTION_COUNT, payload })

export const toggleRecordingState = payload => ({ type: OPENTOK_RECORDING_TOGGLE, payload })

export const toggleStreamStarting = payload => ({ type: OPENTOK_STREAM_STARTING_TOGGLE, payload })

export const initCandidateSession = (payload) => {
  const session = OT.initSession(payload.apiKey, payload.sessionId)
  return { type: OPENTOK_CANDIDATE_SESSION_INIT, session }
}

export const initOpentokRecordingSession = (payload) => {
  const session = OT.initSession(payload.apiKey, payload.sessionId)
  return { type: OPENTOK_RECORDING_SESSION_INIT, session }
}

export const uploadSnapshot = (mode, snapshotDataUrl) => (dispatch, getState) => {
  const { publisher, archive } = getState().global.opentok
  if (publisher && archive) {
    const imgData = snapshotDataUrl ? snapshotDataUrl.split(',')[1] : publisher.getImgData()
    const binary = atob(imgData)
    const data = []

    for (let i = 0; i < binary.length; i += 1) {
      data.push(binary.charCodeAt(i))
    }

    const blob = new Blob([new Uint8Array(data)])
    VideoServices.uploadScreenshot(mode, `opentok-archive/${archive.id}`, blob)
  }
}
